import { Meter, Area } from '../types';
import { supabase } from '../lib/supabaseClient';

export const meterService = {
  /**
   * Obtiene la lista de medidores y resuelve el nombre del área asociada a partir de la lista de áreas.
   */
  async fetchMeters(areas: Area[]): Promise<Meter[]> {
    const { data, error } = await supabase
      .from('meters')
      .select('*')
      .order('created_at', { ascending: true });

    if (error) throw error;

    const rawMeters = data || [];
    return rawMeters.map((m: any) => {
      const areaObj = areas.find(a => a.id === m.area_id);
      return {
        id: m.id,
        name: m.name,
        type: m.type,
        unit: m.unit,
        area: areaObj ? areaObj.name : 'Sin Área asignada'
      };
    });
  },

  /**
   * Registra un nuevo medidor asociándole el ID del área correspondiente.
   */
  async addMeter(meter: Omit<Meter, 'id'>, areas: Area[]): Promise<Meter> {
    const foundArea = areas.find(a => a.name === meter.area);
    const areaId = foundArea ? foundArea.id : null;

    const { data, error } = await supabase
      .from('meters')
      .insert({
        name: meter.name,
        type: meter.type,
        unit: meter.unit,
        area_id: areaId
      })
      .select()
      .single();

    if (error) {
      console.error('Error insertando medidor:', error);
      throw error;
    }

    return {
      ...data,
      area: meter.area
    };
  },

  /**
   * Actualiza la información de un medidor.
   */
  async updateMeter(meter: Meter, areas: Area[]): Promise<void> {
    const foundArea = areas.find(a => a.name === meter.area);
    const areaId = foundArea ? foundArea.id : null;

    const { error } = await supabase
      .from('meters')
      .update({
        name: meter.name,
        type: meter.type,
        unit: meter.unit,
        area_id: areaId
      })
      .eq('id', meter.id);

    if (error) {
      console.error('Error actualizando medidor:', error);
      throw error;
    }
  },

  /**
   * Elimina un medidor por su ID.
   */
  async deleteMeter(meterId: string): Promise<void> {
    const { error } = await supabase
      .from('meters')
      .delete()
      .eq('id', meterId);

    if (error) throw error;
  }
};
